// extracted by mini-css-extract-plugin
export default {"textContainer":"References_textContainer__+G9zg"};